<template>
  <div class="user-page">
    <div class="user-profile__section">
      <h1 class="home__title">Профиль пользователя</h1>
      <div class="user-profile__info">
        <div class="user-profile__info-item">
          <span class="user-profile__key">Пользователь:</span>
          <span class="user-profile__data">
            {{ user.name }} {{ user.surname }}
          </span>
        </div>
        <div class="user-profile__info-item">
          <span class="user-profile__key">Номер лицензии:</span>
          <span class="user-profile__data">{{ license.serialNumber }}</span>
        </div>
        <div
          v-for="(field, i) in license.customFields"
          :key="i"
          class="user-profile__info-item"
        >
          <span class="user-profile__key">{{ field.label }}:</span>
          <span class="user-profile__data">{{ field.value }}</span>
        </div>
      </div>
    </div>
    <!-- TODO V2 -->
    <!-- <div class="user-profile__section">
      <h1 class="home__title">Сервисный центр</h1>
      <div class="user-profile">
        <div class="user-profile__info">
          <div
            v-for="(field, i) in serviceInfo"
            :key="i"
            class="user-profile__info-item"
          >
            <span class="user-profile__key">{{ field.label }}:</span>
            <span class="user-profile__data">{{ field.value }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="user-databases">
      <div class="home__title user-database__title">
        Вам доступны следующие базы:
      </div>
      <div
        v-for="database in databases"
        :key="database.domainId"
        class="user-database"
      >
        <div
          class="user-database__icon"
          :style="dbIconStyle(database)"
          :title="database.name"
        />
        <span class="user-database__name">{{ getDbLabel(database) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const serviceInfo = [
  {
    label: 'Адрес',
    value: 'Не дом и не улица'
  },
  {
    label: 'Телефон',
    value: 'ноль ноль ноль'
  },
  {
    label: 'Контактное лицо',
    value: 'Face'
  },
  {
    label: 'Электронная почта',
    value: 'email@email.email'
  },
  {
    label: 'Мессенджеры',
    value: 'ICQ 990432470'
  },
  {
    label: 'Вебсайты',
    value: 'hmpg.net'
  },
  {
    label: 'Дополнительная информация',
    value: 'Не дом и не улица'
  },
  {
    label: 'Данное ПО зарегистрировано на',
    value: 'для Кутузовой Ольги'
  }
];

export default {
  data() {
    return {
      serviceInfo: serviceInfo
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    license() {
      return this.user.license;
    },

    databases() {
      return this.$store.state.databases;
    }
  },

  methods: {
    /**
     * @param {ApiDatabase} database
     * @returns {Object}
     */
    dbIconStyle(database) {
      return { backgroundImage: `url('${database.iconUrl}')` };
    },

    /**
     * @param {ApiDatabase} database
     * @returns {string}
     */
    getDbLabel(database) {
      let label = database.name;

      if (database.name !== database.domainId) {
        label += ` (${database.domainId})`;
      }
      return label;
    }
  },
  metaInfo() {
    return {
      title: this.user
        ? this.user.name + ' ' + this.user.surname
        : 'Пользователь'
    };
  }
};
</script>

<style src="./styles/index.css" />
